'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.onClosingComponent = onClosingComponent;
exports.triggerFetchPaymentMethods = triggerFetchPaymentMethods;
exports.watchCloseComponent = watchCloseComponent;
exports.watchOpenComponent = watchOpenComponent;

var _messageBus = require('@wh/message-bus');

var _effects = require('redux-saga/effects');

var _reduxSaga = require('redux-saga');

var _constants = require('../../constants');

var _actions = require('../../actions');

var _events = require('../../events');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(onClosingComponent),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(triggerFetchPaymentMethods),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(watchCloseComponent),
    _marked4 = /*#__PURE__*/_regenerator2.default.mark(watchOpenComponent);
//compatibility to versions up to 0.15 of redux-sage


var takeEveryEffect = _effects.takeEvery || _reduxSaga.takeEvery;

/**
 * sets the internal component status to 'closing'
 * @returns {void}
 */
function onClosingComponent(action) {
  return _regenerator2.default.wrap(function onClosingComponent$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (action.preventEventTriggering) {
            _context.next = 3;
            break;
          }

          _context.next = 3;
          return (0, _messageBus.publish)(_events.MESSAGE_PUB_QD_CLOSE, {});

        case 3:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

/**
 * Triggers the call to get the customer's payments methods
 * @returns {void}
 */
function triggerFetchPaymentMethods() {
  return _regenerator2.default.wrap(function triggerFetchPaymentMethods$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.put)((0, _actions.fetchPmtMethods)());

        case 2:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

/**
 * Fetch watchClosingComponent Saga
 * @returns {void}
 */
function watchCloseComponent() {
  return _regenerator2.default.wrap(function watchCloseComponent$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return takeEveryEffect(_constants.QD_ACTION_CLOSING, onClosingComponent);

        case 2:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

/**
 * Fetch watchOpenComponent Saga
 * @returns {void}
 */
function watchOpenComponent() {
  return _regenerator2.default.wrap(function watchOpenComponent$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return takeEveryEffect(_constants.QD_ACTION_OPEN_RECEIVED, triggerFetchPaymentMethods);

        case 2:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}